import { atom } from 'jotai';
import { InfoSelectDateModalAtom, Step } from './SelectOrderDateV2.types';
import { INITIAL_STEP, CHANGE_ORDER_DATE_STEP } from './constants';

export const toggleSelectDateModalAtom = atom(false);

export const selectDateModalStepAtom = atom<Step>(CHANGE_ORDER_DATE_STEP[INITIAL_STEP]);

export const infoSelectDateModalAtom = atom<InfoSelectDateModalAtom | null>(null);
